
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.2.0
 * Query Engine version: 78caf6feeaed953168c64e15a249c3e9a033ebe2
 */
Prisma.prismaVersion = {
  client: "5.2.0",
  engine: "78caf6feeaed953168c64e15a249c3e9a033ebe2"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.CommentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  text: 'text',
  context: 'context',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
};

exports.Prisma.ContentResourceScalarFieldEnum = {
  id: 'id',
  type: 'type',
  createdById: 'createdById',
  fields: 'fields',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ContentResourceResourceScalarFieldEnum = {
  resourceOfId: 'resourceOfId',
  resourceId: 'resourceId',
  position: 'position',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.LessonProgressScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  lessonId: 'lessonId',
  sectionId: 'sectionId',
  moduleId: 'moduleId',
  lessonSlug: 'lessonSlug',
  lessonVersion: 'lessonVersion',
  completedAt: 'completedAt',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state',
  oauth_token_secret: 'oauth_token_secret',
  oauth_token: 'oauth_token',
  userId: 'userId',
  refresh_token_expires_in: 'refresh_token_expires_in'
};

exports.Prisma.CouponScalarFieldEnum = {
  id: 'id',
  code: 'code',
  createdAt: 'createdAt',
  expires: 'expires',
  maxUses: 'maxUses',
  default: 'default',
  merchantCouponId: 'merchantCouponId',
  status: 'status',
  usedCount: 'usedCount',
  percentageDiscount: 'percentageDiscount',
  restrictedToProductId: 'restrictedToProductId',
  bulkPurchaseId: 'bulkPurchaseId'
};

exports.Prisma.MerchantAccountScalarFieldEnum = {
  id: 'id',
  status: 'status',
  createdAt: 'createdAt',
  label: 'label',
  identifier: 'identifier'
};

exports.Prisma.MerchantChargeScalarFieldEnum = {
  id: 'id',
  status: 'status',
  identifier: 'identifier',
  amount: 'amount',
  fee: 'fee',
  refundAmount: 'refundAmount',
  net: 'net',
  metadata: 'metadata',
  userId: 'userId',
  merchantAccountId: 'merchantAccountId',
  merchantProductId: 'merchantProductId',
  createdAt: 'createdAt',
  merchantCustomerId: 'merchantCustomerId'
};

exports.Prisma.MerchantCouponScalarFieldEnum = {
  id: 'id',
  identifier: 'identifier',
  status: 'status',
  merchantAccountId: 'merchantAccountId',
  percentageDiscount: 'percentageDiscount',
  type: 'type'
};

exports.Prisma.MerchantCustomerScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  merchantAccountId: 'merchantAccountId',
  identifier: 'identifier',
  createdAt: 'createdAt',
  status: 'status'
};

exports.Prisma.MerchantPriceScalarFieldEnum = {
  id: 'id',
  merchantAccountId: 'merchantAccountId',
  merchantProductId: 'merchantProductId',
  status: 'status',
  identifier: 'identifier',
  createdAt: 'createdAt',
  priceId: 'priceId'
};

exports.Prisma.MerchantProductScalarFieldEnum = {
  id: 'id',
  merchantAccountId: 'merchantAccountId',
  productId: 'productId',
  status: 'status',
  identifier: 'identifier',
  createdAt: 'createdAt'
};

exports.Prisma.MerchantSessionScalarFieldEnum = {
  id: 'id',
  identifier: 'identifier',
  merchantAccountId: 'merchantAccountId'
};

exports.Prisma.PriceScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  nickname: 'nickname',
  status: 'status',
  unitAmount: 'unitAmount',
  createdAt: 'createdAt'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  name: 'name',
  productType: 'productType',
  key: 'key',
  createdAt: 'createdAt',
  status: 'status',
  quantityAvailable: 'quantityAvailable'
};

exports.Prisma.ProductRevenueSplitScalarFieldEnum = {
  id: 'id',
  type: 'type',
  productId: 'productId',
  percent: 'percent',
  userId: 'userId',
  createdAt: 'createdAt'
};

exports.Prisma.UpgradableProductsScalarFieldEnum = {
  upgradableToId: 'upgradableToId',
  upgradableFromId: 'upgradableFromId'
};

exports.Prisma.PurchaseScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  createdAt: 'createdAt',
  totalAmount: 'totalAmount',
  ip_address: 'ip_address',
  city: 'city',
  state: 'state',
  country: 'country',
  couponId: 'couponId',
  bulkCouponId: 'bulkCouponId',
  redeemedBulkCouponId: 'redeemedBulkCouponId',
  productId: 'productId',
  merchantChargeId: 'merchantChargeId',
  merchantSessionId: 'merchantSessionId',
  upgradedFromId: 'upgradedFromId',
  status: 'status'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  roles: 'roles',
  fields: 'fields'
};

exports.Prisma.UserPrefsScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  fields: 'fields',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  token: 'token',
  identifier: 'identifier',
  expires: 'expires',
  createdAt: 'createdAt'
};

exports.Prisma.DeviceVerificationScalarFieldEnum = {
  deviceCode: 'deviceCode',
  userCode: 'userCode',
  expires: 'expires',
  createdAt: 'createdAt',
  verifiedAt: 'verifiedAt',
  verifiedByUserId: 'verifiedByUserId'
};

exports.Prisma.DeviceAccessTokenScalarFieldEnum = {
  token: 'token',
  createdAt: 'createdAt',
  userId: 'userId'
};

exports.Prisma.PurchaseUserTransferScalarFieldEnum = {
  id: 'id',
  transferState: 'transferState',
  purchaseId: 'purchaseId',
  sourceUserId: 'sourceUserId',
  targetUserId: 'targetUserId',
  createdAt: 'createdAt',
  expiresAt: 'expiresAt',
  canceledAt: 'canceledAt',
  confirmedAt: 'confirmedAt',
  completedAt: 'completedAt'
};

exports.Prisma.BookmarkScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  resourceId: 'resourceId',
  type: 'type',
  fields: 'fields',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.PurchaseUserTransferState = exports.$Enums.PurchaseUserTransferState = {
  AVAILABLE: 'AVAILABLE',
  INITIATED: 'INITIATED',
  VERIFIED: 'VERIFIED',
  CANCELED: 'CANCELED',
  EXPIRED: 'EXPIRED',
  CONFIRMED: 'CONFIRMED',
  COMPLETED: 'COMPLETED'
};

exports.Prisma.ModelName = {
  Comment: 'Comment',
  ContentResource: 'ContentResource',
  ContentResourceResource: 'ContentResourceResource',
  LessonProgress: 'LessonProgress',
  Account: 'Account',
  Coupon: 'Coupon',
  MerchantAccount: 'MerchantAccount',
  MerchantCharge: 'MerchantCharge',
  MerchantCoupon: 'MerchantCoupon',
  MerchantCustomer: 'MerchantCustomer',
  MerchantPrice: 'MerchantPrice',
  MerchantProduct: 'MerchantProduct',
  MerchantSession: 'MerchantSession',
  Price: 'Price',
  Product: 'Product',
  ProductRevenueSplit: 'ProductRevenueSplit',
  UpgradableProducts: 'UpgradableProducts',
  Purchase: 'Purchase',
  Session: 'Session',
  User: 'User',
  UserPrefs: 'UserPrefs',
  VerificationToken: 'VerificationToken',
  DeviceVerification: 'DeviceVerification',
  DeviceAccessToken: 'DeviceAccessToken',
  PurchaseUserTransfer: 'PurchaseUserTransfer',
  Bookmark: 'Bookmark'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
